import VaccinesIcon from '@mui/icons-material/CalendarMonth';
import { ScheduleList } from './Schedule.List';
import { ScheduleCreate } from './Schedule.Create';
import { ScheduleEdit } from './Schedule.Edit';
import { ScheduleUpload } from './Schedule.Upload';
import { GenerateSchedule } from './Schedule.Generate';

export default {
    list: ScheduleList,
    create: ScheduleCreate,
    edit: ScheduleEdit,
    upload: ScheduleUpload,
    generate: GenerateSchedule,
    icon: VaccinesIcon,
};
